/**
 * Serializes nested params the way the API's filter syntax expects:
 * `filter[0][field]=contract_id&filter[0][operator]==&filter[0][value]=48`.
 * Axios' default serializer flattens arrays to `filter[]=`, which the endpoint
 * reads as a filter with no field and ignores.
 */
export const paramsSerializer = (params: Record<string, unknown>): string => {
  const usp = new URLSearchParams();

  const append = (key: string, value: unknown) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      value.forEach((item, index) => append(`${key}[${index}]`, item));
    } else if (typeof value === "object") {
      Object.entries(value as Record<string, unknown>).forEach(([k, v]) => append(`${key}[${k}]`, v));
    } else {
      usp.append(key, String(value));
    }
  };

  Object.entries(params).forEach(([key, value]) => append(key, value));

  return usp.toString();
};
